import { render, staticRenderFns } from "./campaniascomerciales.vue?vue&type=template&id=562c5fce&scoped=true"
import script from "./campaniascomerciales.vue?vue&type=script&lang=js"
export * from "./campaniascomerciales.vue?vue&type=script&lang=js"
import style0 from "./campaniascomerciales.vue?vue&type=style&index=0&id=562c5fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562c5fce",
  null
  
)

export default component.exports